<template>
  <v-container class="ml-n4">
    <v-data-table
      class="border-table"
      density="compact"
      :headers="headers"
      hide-no-data
      item-value="id"
      :items="locations">
      <template #item="{ item }">
        <tr>
          <td>
            <b>{{ item.name }}</b
            ><br />{{ item.description }}
          </td>
          <td>{{ item.staff_availability_after_deductions_location }}</td>
          <td>{{ item.calculated_interest_rate_percentage_location }}</td>
          <td>{{ item.electricity_price_location }}</td>
          <td>
            <ActionButtons
              :clone-action="() => cloneAction(item.id)"
              :delete-action="() => deleteAction(item.id)"
              :edit-action="() => editAction(item.id)" />
          </td>
        </tr>
      </template>

      <template #tfoot>
        <tr>
          <td colspan="5">
            <v-row>
              <v-col
                cols="12"
                md="4">
                <v-text-field
                  v-model="cachedLoadProps.search"
                  class="my-4 mx-2"
                  clearable
                  :label="$t('actions.search')"
                  prepend-inner-icon="mdi-magnify" />
              </v-col>
              <v-spacer />
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script setup>
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { useTranslation } from "i18next-vue";

import ActionButtons from "../ActionButtons.vue";
import { useSpaceStore } from "../../../stores/spaceStore";

const { t } = useTranslation();
const spaceStore = useSpaceStore();

const headers = computed(() => [
  {
    title: t("entities.location.fields.name"),
    align: "start",
    sortable: false,
    key: "name"
  },
  {
    title: t(
      "entities.location.fields.staff_availability_after_deductions_location"
    ),
    key: "staff_availability_after_deductions_location",
    sortable: true
  },
  {
    title: t(
      "entities.location.fields.calculated_interest_rate_percentage_location"
    ),
    key: "calculated_interest_rate_percentage_location",
    sortable: true
  },
  {
    title: t("entities.location.fields.electricity_price_location"),
    key: "electricity_price_location",
    sortable: true
  },
  {
    title: "",
    key: "actions",
    sortable: false
  }
]);

const cachedLoadProps = ref({
  page: 1,
  itemsPerPage: 10,
  sortBy: [],
  search: ""
});

const locations = computed(() => {
  return Object.entries(spaceStore.calculationElements).reduce(
    (result, [id, element]) => {
      if (id.endsWith("location")) {
        result.push(Object.assign({}, element, { id }));
      }
      return result;
    },
    []
  );
});

const router = useRouter();

const cloneAction = (clone_id) => {
  spaceStore.prepareClone(clone_id);
  spaceStore.cloneOnServer(undefined, false);

  // router.push({
  //   name: "calculations-location",
  //   params: { nodeId: id }
  // });
};

const editAction = (id) => {
  router.push({
    name: "calculations-location",
    params: { nodeId: id }
  });
};

const deleteAction = (id) => {
  spaceStore.removeElement(id);
};
</script>

<style scoped>
.border-table {
  border: 1px solid red;
}

:deep() .v-table .v-table__wrapper > table > thead > tr > th:not(:last-child) {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

:deep() .v-table .v-table__wrapper > table > tbody > tr > td:not(:last-child),
.v-table .v-table__wrapper > table > tbody > tr > th:not(:last-child) {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}
</style>
